import Button from 'src/components/atoms/Button/Button'
//import { Social } from 'src/components/molecules/SiteLinks/SiteLinks.style'
import { styled } from 'src/styles/stitches.config'

export const StyledHeader = styled('div', {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 5,
    paddingTop: '$sm',
    paddingBottom: '$sm',
    color: '$brandText',

    [`${Button}`]: {
        borderColor: '$brandText',
        color: '$brandText',
        fontWeight: '$medium',
    },

    '.logo-svg': {
        fill: '$primary',
    },

    '&.light': {
        color: '$brandText',
        [`${Button}`]: {
            borderColor: '$brandText',
            color: '$brandText',
            fontWeight: '$medium',
        },

        // [`${Social}`]: {
        //     backgroundColor: '$white',
        //     color: '$brand',
        // },

        '.logo-svg': {
            fill: '$white',
        },
    },
})
